import {
  Applicant,
  InsuredPeopleDto,
  OnboardingPeriodDto,
} from '@zorro/clients';
import { calculateAgeForEnrollment } from '@zorro/common-utils';

export const getApplicantsFromInsured = (
  email: string,
  insured?: InsuredPeopleDto,
  onboardingPeriod?: OnboardingPeriodDto
): Applicant[] => {
  if (!insured || !onboardingPeriod) {
    return [];
  }

  const employee: Applicant = {
    age: calculateAgeForEnrollment(
      insured.employee.dateOfBirth,
      onboardingPeriod.effectiveFrom
    ),
    isSmoker: insured.employee.isSmoker,
    isChild: false,
    isEmployee: true,
    dateOfBirth: insured.employee.dateOfBirth,
    firstName: insured.employee.firstName,
    lastName: insured.employee.lastName,
    email,
  };

  const spouse = insured.spouse
    ? {
        age: calculateAgeForEnrollment(
          insured.spouse.dateOfBirth,
          onboardingPeriod.effectiveFrom
        ),
        isSmoker: insured.spouse.isSmoker,
        isChild: false,
        isEmployee: false,
        dateOfBirth: insured.spouse.dateOfBirth,
        firstName: insured.spouse.firstName,
        lastName: insured.spouse.lastName,
      }
    : undefined;

  const dependents = insured.dependents
    ? insured.dependents.map((dependent) => {
        const age = calculateAgeForEnrollment(
          dependent.dateOfBirth,
          onboardingPeriod.effectiveFrom
        );
        return {
          age,
          isSmoker: dependent.isSmoker,
          isChild: age < 26,
          isEmployee: false,
          dateOfBirth: dependent.dateOfBirth,
          firstName: dependent.firstName,
          lastName: dependent.lastName,
        };
      })
    : [];

  return [employee, ...(spouse ? [spouse] : []), ...dependents];
};
